module.exports = __webpack_public_path__ + "static/img/r_011.3e783eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_011.jpg
// module id = VVM8
// module chunks = 1